import React from 'react';
import DropdownGeneral from '../DropdownGeneral/DropdownGeneral';
import { DropdownEcosystemProps } from './DropdownEcosystem.type';
const list = [
  {
    value: 'all',
    label: 'All Ecosystem'
  },
  {
    value: '0',
    label: 'Mythic Event'
  },
  {
    value: '1',
    label: 'Riftstorm'
  },
  {
    value: '2',
    label: 'Repository'
  },
  {
    value: '3',
    label: 'Event (Mythic Report)'
  }
];
const DropdownEcosystem: React.FC<DropdownEcosystemProps> = ({
  defaultValue,
  onChange,
  disabled = false
}) => {
  return (
    <DropdownGeneral
      disabled={disabled}
      data-testid="dropdown-ecosystem"
      placeholder="Anomaly Rating"
      onChange={onChange}
      list={list}
      defaultValue={defaultValue ?? 'all'}
    />
  );
};

export default DropdownEcosystem;
